//@ts-check
import SmrClient from "Utils/Requests/SmrClient";

class AppRequests {
    async GetServiceStateBeforeLogin() {
        return await SmrClient.FetchJson({
            url: 'settings/GetServiceStateBeforeLogin',
            method: 'GET'
        });
    }

    /**
     * @returns {Promise<ServiceState>}
     */
    async GetServiceState() {
        return await SmrClient.FetchJson({
            url: 'settings/GetServiceState',
            method: 'GET'
        });
    }

    PrintSmrStartError() {
        SmrClient.Download({
            url: 'admin/PrintServerError',
            method: 'GET'
        });
    }
}

export default new AppRequests;